import React from 'react'
import { Icon, hyphenate } from '@islandsstofa/react'

import cn from 'classnames'

type CheckboxType = {
  id: string
  checked: boolean
  onChange: () => void
  label: string
  containerClass?: string
}

const Checkbox = ({
  id,
  checked,
  onChange,
  label,
  containerClass = ''
}: CheckboxType) => {
  return (
    <div
      className={cn(
        'checkbox-container filter-dropdown__input',
        containerClass,
        {
          'checkbox-container--checked': checked
        }
      )}
    >
      <div className='checkbox'>
        <input onChange={onChange} checked={checked} type='checkbox' id={id} />
        <Icon
          containerClass={cn('checkbox__icon completeCenter h-100 w-100')}
          type='check'
        />
      </div>
      <label className='ml-1 pl-1' htmlFor={id}>
        {hyphenate(label)}
      </label>
    </div>
  )
}

export default Checkbox
